import * as React from "react";
import {buildRefToFooterOrigin, joinClassNames} from "../utils/utils";

const FootNotes = ({contentSections}) => {

  if (!contentSections || !Array.isArray(contentSections)) {
    return null;
  }

    const footers = []
    contentSections.forEach((contentSection) => {
        if (contentSection.StaticContentElements) {
          contentSection.StaticContentElements.forEach((contentElement) => {
            if (contentElement.RichTextWrapper && contentElement.RichTextWrapper.Footers) {
              contentElement.RichTextWrapper.Footers.forEach((footer) => (footers.push(footer)))
            }
          })
        }
        if (contentSection.ScalableContentElements) {
          contentSection.ScalableContentElements.forEach((contentElement) => {
            if (contentElement.RichTextWrapper && contentElement.RichTextWrapper.Footers) {
              contentElement.RichTextWrapper.Footers.forEach((footer) => (footers.push(footer)))
            }
          })
        }
      }
    )

    const isThereAtLeastOneFootNote = footers.length > 0;

    return (
        <section
            className={joinClassNames(isThereAtLeastOneFootNote ? 'pt-2 pb-2 border-t border-gray-900' : '', 'px-4 mx-auto w-full max-w-7xl bg-white')}
            key="footNotes">
            <ul className="list-decimal my-0 py-0">
                {
                    footers.map((footer) => (
                        <li id={footer.FooterId}>
                            {footer.DisplayedText} <a href={buildRefToFooterOrigin(footer.FooterId)}>↑</a>
                        </li>
                    )

                )}
            </ul>
        </section>
    )
}

export default FootNotes;